const ROOT = 'user_metadata';

export const FETCH_USER_METADATA_REQUEST = `${ROOT}/FETCH_USER_METADATA_REQUEST`;
export const FETCH_USER_METADATA_SUCCESS = `${ROOT}/FETCH_USER_METADATA_SUCCESS`;
export const FETCH_USER_METADATA_FAILURE = `${ROOT}/FETCH_USER_METADATA_FAILURE`;
